export enum UserRole {
	USER = "ROLE_USER",
	ADMIN_GROUP = "ROLE_ADMIN_GROUP",
	ADMIN_ORG = "ROLE_ADMIN_ORG",
	ADMIN_ITI_DS = "ROLE_ADMIN_ITI_DS",
	STEWARD = "ROLE_DATA_STEWARD",
}
